"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../lib/messages"));
const AddToCalendarButton_1 = __importDefault(require("../../../components/Header/AddToCalendarButton"));
const button_1 = __importDefault(require("@kyruus/button"));
const react_2 = require("@xstate/react");
const styles_1 = require("./styles");
const constants_1 = require("../../lib/constants");
const utils_1 = require("../../../lib/utils");
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const SummaryCtaPortal_1 = __importDefault(require("../../../components/ApptSummary/ApptDetails/SummaryCtaPortal"));
const types_1 = require("../../../components/LayoutFactory/types");
const useManageAppointmentContext_1 = require("../../hooks/useManageAppointmentContext");
const Tracking_1 = require("../../lib/constants/Tracking");
const Confirmation = ({ service, intl, bodyIsAnimating }) => {
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const [state] = (0, react_2.useService)(service);
    const { context } = state;
    const isAppointmentChanged = state.matches(constants_1.states.appointmentRescheduled) &&
        !context.keptOriginalAppointment;
    const title = isAppointmentChanged
        ? messages_1.default.appointmentRescheduleSuccessMessageTitle
        : messages_1.default.appointmentUnchangedSuccessMessageTitle;
    const description = isAppointmentChanged
        ? messages_1.default.appointmentRescheduleSuccessMessage
        : messages_1.default.appointmentUnchangedSuccessMessage;
    const formattedAppointmentDate = (0, utils_1.getAppointmentDate)({ start_datetime: context.appointment.start_datetime }, 'MMMM DD, YYYY');
    const providerName = (0, utils_1.makeNameString)({
        first: context.provider.name.first,
        last: context.provider.name.last,
        middle: context.provider.name.middle
    });
    const handlePrint = (e) => {
        track(Tracking_1.userEvents.PRINT);
        if (!e.isDefaultPrevented()) {
            const printStyles = `
        @media print {
          body, html {
            height: auto;
          }
        }
      `;
            const styleSheet = document.createElement('style');
            styleSheet.innerText = printStyles;
            document.head.appendChild(styleSheet);
            window.print();
            window.onafterprint = () => {
                document.head.removeChild(styleSheet);
            };
        }
    };
    const onEventClick = (0, react_1.useCallback)((mode) => {
        track(Tracking_1.userEvents.ADD_TO_CALENDAR, { mode });
    }, [track]);
    return (react_1.default.createElement(styles_1.StyledConfirmationContainer, { "data-testid": "confirmation-container", id: "print-reschedule-content", isAboveMd: aboveMd },
        react_1.default.createElement(styles_1.StyledConfirmationTitle, { "data-testid": "confirmation-title" },
            react_1.default.createElement(CheckCircle_1.default, { "aria-hidden": "true" }),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, title))),
        react_1.default.createElement(styles_1.StyledConfirmationBody, null,
            react_1.default.createElement(styles_1.StyledConfirmationDescription, { "data-testid": "confirmation-description" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, description, { values: {
                        provider_name: providerName,
                        appointment_date: formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedDate,
                        appointment_time: formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedTime
                    } }))),
            react_1.default.createElement(SummaryCtaPortal_1.default, { aboveMd: aboveMd, target: types_1.PMC_APP_CONTAINER_ID, bodyIsAnimating: bodyIsAnimating },
                react_1.default.createElement(styles_1.StyledConfirmationAction, { "data-testid": "confirmation-actions", aboveMd: aboveMd },
                    react_1.default.createElement(styles_1.StyledPrintButtonContainer, null,
                        react_1.default.createElement(button_1.default, { "data-testid": "print-button", type: "button", "aria-label": intl.formatMessage(messages_1.default.ariaPrintConfirmation), onClick: handlePrint },
                            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.printButtonText)))),
                    react_1.default.createElement(AddToCalendarButton_1.default, { onEventClick: onEventClick, provider: context.provider, appointment: context.appointment, location: context.appointment.location }))))));
};
exports.default = (0, intl_1.injectIntl)(Confirmation);
//# sourceMappingURL=Confirmation.js.map